/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { RenderInput } from '#components/support/forms/utility/index.js';
import BasicReduxFormSelectMenu from '#components/support/forms/SelectMenus/BasicReduxFormSelectMenu/index.jsx';

const items = [
  { id: 'all', name: 'All', value: 'all' },
  { id: 'risk-model', name: 'Risk Model - All', value: 'risk-model' },
  { id: 'std', name: 'Risk Model - Standard', value: 'std' },
  { id: 'std-rt', name: 'Risk Model - Standard + RT', value: 'std-rt' },
  { id: 'adv', name: 'Risk Model - Advanced', value: 'adv' },
  { id: 'adv-rt', name: 'Risk Model - Advanced + RT', value: 'adv-rt' },
  { id: 'sh', name: 'Site Hazards', value: 'sh' },
];

type Props = {|
  name: string,
|};

const ModelLevelSelectMenu = ({ name }: Props): Element<typeof BasicReduxFormSelectMenu> => (
  <BasicReduxFormSelectMenu
    id={name}
    name={name}
    component={RenderInput}
    items={items}
    inputClassName={classNames('custom-select', 'model-level-select')}
    includeEmptyOption={false}
  />
);

export default ModelLevelSelectMenu;
